import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PANEL_ITEM_PADDING_CSS } from '../../../../panels/panelItem';
import { LIGHT_BLUE_COLOR } from '../../../../styles/colors';
const ITEM_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    gap: 10px;
  `);
const ITEM_VALUE_CSS = css `
  flex-grow: 1;
  text-align: end;
  color: ${LIGHT_BLUE_COLOR};
`;
/**
 * Includes whitespace and line breaks so that there will be a readable format when textContent of the panel is copied to clipboard.
 */
export const DebugItemContainer = ({ title, value }) => {
    return (_jsxs("div", { css: ITEM_CSS, children: [_jsxs("span", { children: [title, ":"] }), " ", _jsx("span", { css: ITEM_VALUE_CSS, children: value }), '\n'] }));
};
